import React from 'react';
import { useNavigate } from 'react-router-dom';

const Navbar = ({ toggleSidebar, onLogout }) => {
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button className="toggle-btn" onClick={toggleSidebar}>
          ☰
        </button>
        <div className="navbar-title">Sports Equipment Management</div>
      </div>
      <div className="navbar-right">
        <button
          type="button"
          className="navbar-dev-link"
          onClick={() => navigate('/about')}
        >
          WeConnectInnovation_Developer
        </button>
        <span>{new Date().toLocaleDateString()}</span>
        <button className="btn btn-danger navbar-logout-btn" onClick={onLogout}>
          Logout
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
